import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Profile from "../components/Profile";

function ProfilePage() {
  const { userId, projectId } = useParams();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  const host = process.env.REACT_APP_SERVER;

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);

      try {
        const response = await fetch(`${host}/api/profile/${userId}`);
        const jsonData = await response.json();

        if (jsonData.status === "success") {
          setUser(jsonData.data.user); // Assuming the user data is in the 'rows' array
        } else {
          console.error(jsonData.message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [userId, host]);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!user) {
    return <p>User not found.</p>;
  }

  return (
    <div className="container mx-auto w-full">
      <div className="text-sm breadcrumbs pb-5 pl-5">
        <ul>
          <li>
            <Link to={`/`} className="text-blue-500">
              <a>Home</a>
            </Link>
          </li>
          <li>
            <Link to={`/projects`} className="text-blue-500">
              <a>Projects</a>
            </Link>
          </li>
          <li>
            <Link to={`/projects/${projectId}`} className="text-blue-500">
              <a>{projectId}</a>
            </Link>
          </li>
          <li>
            <Link to={`/projects/${userId}`} className="text-blue-500">
              <a>{userId}</a>
            </Link>
          </li>
        </ul>
      </div>
      {user ? <Profile user={user} /> : <p>Loading user data...</p>}
    </div>
  );
}

export default ProfilePage;
